(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["soriq-product-card-styles"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const qtyBtn = event.target.closest('[data-soriq-qty]');
    if (qtyBtn) {
      const wrap = qtyBtn.closest('[data-soriq-qty-wrap]');
      const input = wrap?.querySelector('[data-soriq-qty-input]');
      if (!input) return;
      const step = parseInt(qtyBtn.dataset.soriqQty, 10);
      const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
      input.value = String(next);
      return;
    }

    const variantBtn = event.target.closest('[data-soriq-variant-id]');
    if (!variantBtn) return;

    const card = variantBtn.closest('[data-soriq-product-card]');
    if (!card) return;

    const variantId = variantBtn.dataset.soriqVariantId;
    const price = variantBtn.dataset.soriqVariantPrice;
    const compare = variantBtn.dataset.soriqVariantCompare;
    const priceCents = parseInt(variantBtn.dataset.soriqVariantPriceCents || '0', 10);
    const compareCents = parseInt(variantBtn.dataset.soriqVariantCompareCents || '0', 10);
    const available = variantBtn.dataset.soriqVariantAvailable === 'true';

    card.querySelectorAll('[data-soriq-variant-id]').forEach((btn) => {
      btn.classList.toggle('is-active', btn === variantBtn);
      btn.setAttribute('aria-pressed', btn === variantBtn ? 'true' : 'false');
    });

    const idInput = card.querySelector('[data-soriq-variant-input]');
    if (idInput) idInput.value = variantId;

    const priceEl = card.querySelector('[data-soriq-price]');
    if (priceEl && price) priceEl.textContent = price;

    const compareEl = card.querySelector('[data-soriq-compare]');
    if (compareEl) {
      if (compare) {
        compareEl.textContent = compare;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    const discountEl = card.querySelector('[data-soriq-discount]');
    if (discountEl && compareCents > priceCents && compareCents > 0) {
      const pct = Math.round(((compareCents - priceCents) / compareCents) * 100);
      discountEl.textContent = pct + '% OFF';
      discountEl.hidden = false;
    } else if (discountEl) {
      discountEl.hidden = true;
    }

    const submit = card.querySelector('[data-soriq-submit]');
    if (submit) submit.disabled = !available;
  });
  } catch(e) { console.error(e); }
})();

})();
